<template>
    <div id="container" :type="pageType">
        <div class="page page-guide"  v-ga:request="{pageType, state: guide}" v-ga:page="{pageType, glb: glb, state: guide}">
            <mvtHeader :geoInfo="guide.geo"></mvtHeader>
            <guideArticle v-if="guide.article" :type="guide.articleType" />
            <guideHub v-else-if="guide.isHub" :type="guide.hubType" />
            <div v-else>
                <div class="neighborhood-map" v-if="guide.geo && guide.geo.lat && guide.geo.lng">
                    <mvtNewMap
                        ref="map"
                        :center="{lat: guide.geo.lat, lng: guide.geo.lng}"
                        :zoom="12"
                    ></mvtNewMap>
                </div>
                <div class="grid fixed grid-cols-12">
                    <div class="col-span-12 space">

                        <mvtBreadcrumb :geo="breadcrumbGeo" />

                        <div class="grid xs-grid-cols-1 sm-grid-cols-2">
                            <div>
                                <h1 class="f0 text-bold">{{guide.pageHeading}}</h1>
                                <div class="f5">Everything you need to know about all things real estate.</div>
                            </div>
                            <mvtDropdownList class="categories" :items="getCategories" label="Categories" />
                        </div>

                        <div>
                            <div class="f3 article-headers">Featured articles</div>
                            <div class="grid xs-grid-cols-1 sm-grid-cols-2">
                                <span v-for="article in articles.highlights" :key="article.title">
                                    <featuredArticle class="article-cards"
                                        :viewCount="article.pageViews"
                                        :icon="'icon-user'"
                                        :image="article.featuredImage"
                                        :authorName="article.authorName"
                                        :articleTitle="article.title"
                                        :articleDescription="article.description"
                                        :url="`${glb.appUrl}${article.url}`"
                                    />
                                </span>
                            </div>
                        </div>

                        <div>
                            <div class="f3 article-headers">Library</div>
                            <tabGroup :tabs="tabs" :initialTab="'latest'">
                                <template v-slot:tab-head-popular>
                                    Popular
                                </template>
                                <template v-slot:tab-panel-popular>
                                    <div v-if="articles.popular && articles.popular.length > 0" class="grid xs-grid-cols-1 sm-grid-cols-3">
                                        <span v-for="article in articles.popular" :key="article.title">
                                            <featuredArticle class="article-cards"
                                                :viewCount="article.pageViews"
                                                :icon="'icon-user'"
                                                :image="article.featuredImage"
                                                :authorName="article.authorName"
                                                :articleTitle="article.title"
                                                :articleDescription="article.description"
                                                :url="`${glb.appUrl}${article.url}`"
                                            />
                                        </span>
                                    </div>
                                    <div v-else>
                                        <div>
                                            <div class="flex center text-bold">No Articles Available</div>
                                            <a class="flex center link" href="/guide/">Guide Home</a>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:tab-head-latest>
                                    Latest
                                </template>
                                <template v-slot:tab-panel-latest>
                                    <div v-if="articles.latest && articles.latest.length > 0" class="grid xs-grid-cols-1 sm-grid-cols-3">
                                        <span v-for="article in articles.latest" :key="article.title">
                                            <featuredArticle class="article-cards"
                                                :viewCount="article.pageViews"
                                                :icon="'icon-user'"
                                                :image="article.featuredImage"
                                                :authorName="article.authorName"
                                                :articleTitle="article.title"
                                                :articleDescription="article.description"
                                                :url="`${glb.appUrl}${article.url}`"
                                            />
                                        </span>
                                    </div>
                                    <div v-else>
                                        <div>
                                            <div class="flex center text-bold">No Articles Available</div>
                                            <a class="flex center link" href="/guide/">Guide Home</a>
                                        </div>
                                    </div>
                                </template>
                            </tabGroup>
                            <guidePaginate v-if="articles.latest && articles.latest.length > 0 && articles.popular && articles.popular.length > 0"/>
                        </div>

                        <div>
                            <header class="text-bold article-headers">Homes near you</header>
                            <mvtNearby type="location" />
                        </div>
                    </div>
                </div>
            </div>
            <mvtFooter :geoInfo="guide.geo"/>
        </div>
        <mvtPopSignin />
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-guide.js"></script>

<style lang="scss">
@use "./page-guide.scss" as *;
</style>
